/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_COUNTRY_DETAILS_REQUEST,
  FETCH_COUNTRY_DETAILS_SUCCESS,
  FETCH_COUNTRY_DETAILS_FAILURE,
} from "./CountryDetailsTypes";

const initialState = {
  loading: false,
  countries: [],
  error: "",
};

const countryDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_COUNTRY_DETAILS_SUCCESS:
      return {
        loading: false,
        countries: action.payload,
        error: "",
      };
    case FETCH_COUNTRY_DETAILS_FAILURE:
      return {
        loading: false,
        countries: [],
        error: action.payload,
      };

    default:
      return state;
  }
};

export default countryDetailsReducer;
